var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 10C0 4.47715 4.47715 0 10 0H22C27.5228 0 32 4.47715 32 10V22C32 27.5228 27.5228 32 22 32H10C4.47715 32 0 27.5228 0 22V10Z",
    fill: "#FDF2F8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.333 10.6665H10.6663C9.92996 10.6665 9.33301 11.2635 9.33301 11.9998V19.9998C9.33301 20.7362 9.92996 21.3332 10.6663 21.3332H21.333C22.0694 21.3332 22.6663 20.7362 22.6663 19.9998V11.9998C22.6663 11.2635 22.0694 10.6665 21.333 10.6665Z",
    stroke: "#E60076",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6663 12.6665L16.6863 16.4665C16.4805 16.5955 16.2426 16.6638 15.9997 16.6638C15.7568 16.6638 15.5188 16.5955 15.313 16.4665L9.33301 12.6665",
    stroke: "#E60076",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.6f8ba437d474018ad8301edd5ec7acc6.svg";
export { ForwardRef as ReactComponent };